import { Api } from './axios-config';

export interface ISconAppStatus {
  connected: boolean;
  instanceName: string;
  phoneNumber: string;
}

export interface ISconAppConnectResult {
  instanceName: string;
  qrCodeBase64: string;
  connected: boolean;
  phoneNumber: string;
}

const getStatus = async (): Promise<ISconAppStatus> => {
  const { data } = await Api.get<ISconAppStatus>('/sconapp/whatsapp/status');
  return data;
};

const connect = async (): Promise<ISconAppConnectResult> => {
  const { data } = await Api.post<ISconAppConnectResult>('/sconapp/whatsapp/connect');
  return data;
};

const disconnect = async (): Promise<void> => {
  await Api.post('/sconapp/whatsapp/disconnect');
};

const isConnected = async (): Promise<boolean> => {
  const { data } = await Api.get<{ connected: boolean }>('/sconapp/whatsapp/is-connected');
  return data.connected;
};

export const sconAppService = {
  getStatus,
  connect,
  disconnect,
  isConnected,
};
